<template>
  <a href="/cart/" class="fixed-cart" v-if="cart && cart.counts > 0">
    <i class="bi bi-bag-plus fixed-cart__icon"></i>
    <span class="fixed-cart__counts">{{ cart.counts }}</span>
  </a>
</template>

<script>
import axios from 'axios'
import CartMixin from '../vue_mixins/CartMixin.vue'

export default {
  name: 'CartBlock',
  mixins: [CartMixin],
  mounted() {
    axios.get("/cart/api/cart/" + `?timestamp=${new Date().getTime()}`).then(response => {
      this.cart = response.data
    });
  },
}
</script>

<style lang="scss">
</style>
